var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m983.57 634.96-529.84 414.95c-28.715 22.488-67.055-2.5938-65.52-41.195l-4.0195-819.42c-0.097656-38.41 37.633-60.504 65.004-39.648l534.57 406.2c25.02 19.031 24.371 60.59-0.20312 79.117z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m197.73 169.12c0-62.184 94.535-62.184 94.535 0v861.78c0 62.184-94.535 62.184-94.535 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.fc37787aa8628d898e96105b3b505ffc.svg";
export { ForwardRef as ReactComponent };